export default {
  "app-footer": () => import("/vercel/path0/layouts/AppFooter.vue").then(m => m.default || m),
  "change-theme": () => import("/vercel/path0/layouts/ChangeTheme.vue").then(m => m.default || m),
  "floating-btn": () => import("/vercel/path0/layouts/FloatingBtn.vue").then(m => m.default || m),
  "nav-links": () => import("/vercel/path0/layouts/NavLinks.vue").then(m => m.default || m),
  default: () => import("/vercel/path0/layouts/default.vue").then(m => m.default || m),
  error: () => import("/vercel/path0/layouts/error.vue").then(m => m.default || m)
}